import ConsultPrepaidApplicationFormUI from '@Modules/cardManagementSystem/prepaid/components/formsUI/cardHolder/prepaidApplication/consultPrepaidApplication/ConsultPrepaidApplicationFormUI';
import ConsultPrepaidApplicationTableFormUI from '@Modules/cardManagementSystem/prepaid/components/formsUI/cardHolder/prepaidApplication/consultPrepaidApplication/ConsultPrepaidApplicationTableFormUI';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useToast } from '@chakra-ui/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import React from 'react';
import {
  TConsultPrepaidApplicationDataTableData,
  getConsultPrepaidApplicationDataTableColumns
} from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/consultPrepaidApplication/ConsultPrepaidApplicationDatatableMeta';
import ConsultPrepaidApplicationDataTableRowFormMeta from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/consultPrepaidApplication/ConsultPrepaidApplicationDatatableRowMeta';
import ConsultPrepaidApplicationMeta from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/consultPrepaidApplication/ConsultPrepaidApplicationMeta';

const ConsultPrepaidApplicationFormHandler = () => {
  const [rowDataTable, setRowDataTable] =
    React.useState<TConsultPrepaidApplicationDataTableData>({
      primaryKey: '',
      appDateTable: '',
      appIDTable: '',
      clientTable: '',
      deciDateTable: '',
      prepaidProgTable: '',
      cardProgTable: '',
      statusTable: '',
    });

  const fakeDataTable: TConsultPrepaidApplicationDataTableData[] = [
    {
      primaryKey: 1,
      appDateTable: '',
      appIDTable: '',
      clientTable: '',
      deciDateTable: '',
      prepaidProgTable: '',
      cardProgTable: '',
      statusTable: '',
    },
    {
      primaryKey: 2,
      appDateTable: '',
      appIDTable: '',
      clientTable: '',
      deciDateTable: '',
      prepaidProgTable: '',
      cardProgTable: '',
      statusTable: '',
    },
    {
      primaryKey: 3,
      appDateTable: '',
      appIDTable: '',
      clientTable: '',
      deciDateTable: '',
      prepaidProgTable: '',
      cardProgTable: '',
      statusTable: '',
    },
    
  ];

  const editModalRef = React.useRef<any>(null);

  const formModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null);
  
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['ConsultPrepaidApplication'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve(fakeDataTable), 500);
      });
    },
    refetchInterval: 120000,
    refetchIntervalInBackground: true,
    refetchOnMount: true,
    onSuccess: (data_: TConsultPrepaidApplicationDataTableData[]) => {
      console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const queryClient = useQueryClient();


  // ===============================================================================
  const { mutateAsync, isLoading: isSubmitting } = useMutation({
    mutationFn: async (rowData: TConsultPrepaidApplicationDataTableData) => {
      return await new Promise(function (resolve) {
        setTimeout(() => resolve(rowData), 500);
      });
    },
    onSuccess: (updateRowData: any) => {
      console.log('Response: ', data);

      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error: any) => {
      
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const { mutateAsync: mutateDataTable, isLoading: isSubmittingDataTable } = useMutation({
    mutationFn: async (rowData: TConsultPrepaidApplicationDataTableData) => {
      return await new Promise(function (resolve) {
        setTimeout(() => resolve(rowData), 500);
      });
    },
    onSuccess: (updateRowData: any) => {
      console.log('Response: ', data);

      // Only for the simulation
      const data_ = queryClient.setQueryData<TConsultPrepaidApplicationDataTableData[]>(
        queryKey,
        (data) => {
          return data?.map((rowData) => {
            return updateRowData.primaryKey === rowData.primaryKey
              ? updateRowData
              : rowData;
          });
        }
      );

      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error: any) => {
      
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    try {
      await mutateAsync(payload);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmitTable = async (payload: any) => {
    console.log('payload Table: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    try {
      await mutateDataTable(payload);
    } catch (error) {
      console.log(error);
    }
  };
  // ===============================================================================
  

  const handleEdit = (row: any) => {
    setRowDataTable(row.original);

    editModalRef?.current?.onOpen();
  };

  const columns = getConsultPrepaidApplicationDataTableColumns({
    isLoading,
    handleEdit,
  });

  const triggerSubmit = () => {
    formModalRef?.current?.submitBtnRef?.current?.click();
  };

  return (
    <>
      <ConsultPrepaidApplicationFormUI meta={ConsultPrepaidApplicationMeta} onSubmit={onSubmit} isSubmitting={isSubmitting} isLoading={isLoading}/>

      <CustomReactTable
        data={data || fakeDataTable.slice(0, 6)}
        columns={columns}
      />

      <CustomAppModal
        title="Editer"
        ref={editModalRef}
        actionBtn={
          <CustomSaveBtn
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            onClick={() => {
              triggerSubmit();
            }}
          />
        }
        isSubmitting={isSubmitting}
        onClose
        actionBtnText={'Valider'}
        size="3xl"
        isCentered
        closeOnOverlayClick={false}
      >
        <ConsultPrepaidApplicationTableFormUI
          data={rowDataTable}
          meta={ConsultPrepaidApplicationDataTableRowFormMeta}
          onSubmit={onSubmitTable}
          isLoading={isLoading}
          isSubmitting={isSubmittingDataTable}
          ref={formModalRef}
        />
      </CustomAppModal>
    </>
  );
};

export default ConsultPrepaidApplicationFormHandler;
